import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { FieldType } from "@shared/features/form/Form";
import {
  contactSchemaBaseFields,
  withEmailConfirmationValidation,
} from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { marketingEventBus } from "../../marketing.events";
import { FormDialog } from "@shared/features/form/FormDialog";

export function NewsletterDialog() {
  const schema = withEmailConfirmationValidation(
    z.object({
      ...contactSchemaBaseFields,
      organizations: z.string().min(1, "Organizations is required"),
    })
  );

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
    "organizations",
    "message",
  ]);

  const submitNewsletter = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      try {
        marketingEventBus.emitEvent("newsletter:submitted", data);

        const dataWithNameKeys = {
          ...data,
          first_name: data.firstName || "",
          last_name: data.lastName || "",
        };

        return await apiRequest(
          "/api/submit-newsletter/",
          "POST",
          dataWithNameKeys,
          false
        );
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data, variables) => {
      marketingEventBus.emitEvent("newsletter:subscribed", variables);
    },
  });

  return (
    <FormDialog
      dialogName="newsletter"
      title="Get Updates"
      description="Sign up for our newsletter to stay informed about Pollinator's progress and opportunities."
      successTitle="Success!"
      successDescription="Thank you for subscribing to our newsletter. We'll keep you updated on our latest news and opportunities."
      schema={schema}
      fields={fields as FieldType[]}
      onSubmit={submitNewsletter.mutateAsync}
    />
  );
}

export default NewsletterDialog;
